export class App {
  name: string;
  installed_version: string;
  last_version: string;
  description: string;
  id: string;
  price: number;
}
